// extracted by mini-css-extract-plugin
export var carrierIcon = "_yo-0";
export var carrierLogo = "_yo-1";
export var detailsSection = "_yo-2";